import {legacy_createStore as createStore, applyMiddleware} from 'redux';
import cartReducer from './Cart/cartReducer';
import cartMiddleware from './Middlewares/CartMiddleware';

const store = createStore(cartReducer, applyMiddleware(cartMiddleware));

export default store;